export const kaeserahmsuppe = {
	name: 'Käserahmsuppe',
	desc: 'Porree-Käserahmsuppe mit Kartoffeln und Brötchen.',
	image: 4,
	benefits: [
		'Lauch galt einst als Heilpflanze',
		'Viel Vitamin K',
		'Viel Betacarotin',
	],
	opinions: [
		{
			name: 'Max Hermann',
			date: '14. August 2017',
			title: 'Leider kaum gewürzt',
			content: 'Klang lecker, war aber eher fad',
			rating: 2,
		},
		{
			name: 'Frauke Falter',
			date: '6. Juli 2017',
			title: 'Lecker mit Frischkäse',
			content: 'Ich hab mir noch etwas Fischkäse von der Theke dazu geholt. Damit schmeckt die Suppe wirklich gut.',
			rating: 4,
		},
		{
			name: 'Kristina Kautz',
			date: '14. JaFebruarnuar 2017',
			title: 'Kann ich nicht mehr sehen',
			content: 'Die gibt es seit Wochen immer Dienstags. Ich kanns langsam nicht mehr sehen',
			rating: 2,
		},

	],
	recommandation: 'Als Nachtisch villeicht etwas Müsli, das die fehlenden Ballaststoffe liefert.',
	warnings: ['laktose'],
	ingredients: [
		'Lauch',
		{'Butter': 'laktose'},
		{'Weizenmehl': 'weizen, gluten'},
		{'Milch': 'laktose'},
		{'Käse': 'laktose'},
		'Kartoffeln',
		'Knoblauch',
		'Salz',	
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/kaeserahmsuppe.js